<template>
  <div class="products">
    <navigation></navigation>
    <banner :imgList="bannerList"></banner>
    <!-- 产品导航栏 -->
    <div class="productNav" :class="{ fixed: isFixed }">
      <div class="productNavCont">
        <div class="productNavContItems">
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav1' }"
               @click="handleButtonClick9('nav1')">
            <p>主推产品</p>
            <span>Main promoted products</span>
          </div>
          <div class="productNavContLine"></div>
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav2' }"
               @click="handleButtonClick9('nav2')">
            <p>热门产品推荐</p>
            <span>Popular product recommendations</span>
          </div>
          <div class="productNavContLine"></div>
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav3' }"
               @click="handleButtonClick9('nav3')">
            <p>沙画机</p>
            <span>Sand drawing machine</span>
          </div>
          <div class="productNavContLine"></div>
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav4' }"
               @click="handleButtonClick9('nav4')">
            <p>按摩小件产品</p>
            <span>Main promoted products</span>
          </div>
          <div class="productNavContLine"></div>
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav5' }"
               @click="handleButtonClick9('nav5')">
            <p>智能VR</p>
            <span>Intelligent VR</span>
          </div>
          <div class="productNavContLine"></div>
          <div class="productNavContItem" :class="{ active: navActiveButton === 'nav6' }"
               @click="handleButtonClick9('nav6')">
            <p>其他产品</p>
            <span>Other products</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 主推产品 -->
    <div class="recommend">
      <h1>迷彩全新升级</h1>
      <h2>CAMO BRAND NEW UPGRADE</h2>
      <div class="recommendProduct">
        <div class="recommendProductItem">
          <div class="recommendProductItemDiv1">
            <p>New</p>
            <span>迷彩高端定制</span>
            <div class="div1More" @click="handleClick"><h5>More...</h5></div>
          </div>
          <div class="recommendProductItemDiv2">
            <div class="div2Item">
              <div class="div2ItemContent">
                <img src="../assets/img/products/recommend_product.png"/>
                <div class="div2ItemText">
                  <h3>心理压力评测训练系统</h3>
                  <h4>(HY-S1-II型)</h4>
                  <span>采用柔性硅胶加FPC工艺，具备双导脑电、双路脉搏波同步监测，实现脑电分析、hrv心率变异性分析、情绪和精神压力分析、实时血氧、心率、血流灌注指数计算，血管弹性分析。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="recommendNav">
      <div class="recommendNavCont">
        <div class="recommendNavContItems">
          <div class="recommendNavContDiv"></div>
          <div class="recommendNavContItem" :class="{ active: activeButton === 'train' }"
               @click="handleButtonClick('train')">
            <p>训练设备</p>
          </div>
          <div class="recommendNavContItem" :class="{ active: activeButton === 'chair' }"
               @click="handleButtonClick('chair')">
            <p>迷彩极智椅</p>
          </div>
        </div>
        <div class="recommendNavCont2" v-show="showA">
          <div class="recommendNavCont2Div">
            <div class="cont2DivItem">
              <div class="cont2DivItemDiv"></div>
              <div class="cont2DivContent">
                <img src="../assets/img/products/training_equipment.png"/>
                <div class="cont2DivText">
                  <h3>心理训练设备</h3>
                  <h4>健康监测 <span>- 心理指标实时数据采集分析</span></h4>
                  <h4>心理评测 <span>- 试用专业量表，全方位评估，建立心理健康教育档案</span></h4>
                  <h4>心理训练 <span>- 采用3D立体声，全景展示等技术，带您沉浸式体验进行心理治疗和辅导</span></h4>
                  <h4>心理舒缓 <span>- 集生物反馈，放松训练，心理课堂，音乐放松为一体，深度放松多维度心理状态</span></h4>
                </div>
                <div class="cont2DivMore">
                  <div class="cont2More" @click="handleClick2"><h5>More...</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="recommendNavCont2" v-show="showB">
          <div class="recommendNavCont2Div">
            <div class="cont2DivItem">
              <div class="cont2DivItemDiv"></div>
              <div class="cont2DivContent">
                <img src="../assets/img/products/camo_chair.png"/>
                <div class="cont2DivText2">
                  <h3>迷彩极智椅</h3>
                  <h4>双AI智能系统 <span>- AI智能检测+AI智能感知</span></h4>
                  <h4>先进智能传感器 <span>- 定位肩经纬，感知背部曲线</span></h4>
                  <h4>疲劳探索追踪 <span>- 侦测疲劳程度，精准舒缓放松</span></h4>
                  <h4>5D机芯系统 <span>- 机芯技术再升级，高精度按摩滚轮</span></h4>
                  <h4>IPRO双轮揉臀技术 <span>- 深层指压揉臀</span></h4>
                  <h4>万种程序组合 <span>- 13880种手动按摩程序组合，3096种自动按摩巡航组合</span></h4>
                </div>
                <div class="cont2DivMore">
                  <div class="cont2More" @click="handleClick3"><h5>More...</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 热门产品推荐 -->
    <div class="popular">
      <h1>热门产品推荐</h1>
      <h2>POPULAR PRODUCT RECOMMENDATIONS</h2>
      <div class="popularItem">
        <div class="popularItem1" style=" float: left;" @click="handleButtonClick2('system')">
          <span><img class="popularItemImg"
                     :src="systemActiveButton === 'active' ? systemActiveUrl : systemUrl"/></span>
          <p class="popularItemText" :class="{ active: systemActiveButton === 'active' }">心理测评系统</p>
        </div>
        <div class="popularItem1" style=" float: left;" @click="handleButtonClick2('chair')">
          <span><img class="popularItemImg"
                     :src="massageActiveButton === 'active' ? massageActiveUrl : massageUrl"/></span>
          <p class="popularItemText2" :class="{ active: massageActiveButton === 'active' }">按摩椅系列</p>
        </div>
        <div class="popularItem1" style=" float: left;" @click="handleButtonClick2('device')">
          <span><img class="popularItemImg"
                     :src="deviceActiveButton === 'active' ? deviceActiveUrl : deviceUrl"/></span>
          <p class="popularItemText3" :class="{ active: deviceActiveButton === 'active' }">心理测评设备</p>
        </div>
      </div>
    </div>
    <div class="popularProduct" v-show="showC">
      <div class="popular_system">
        <!-- left -->
        <div class="popular_system_left">
          <div class="left_system_content">
            <div class="left_system_item1">
              <div class="left_system_item1_cont">
                <div class="left_system_item1_text">
                  <p>心理压力评测训练系统(HY-S3)</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div" :class="{ active: sysActiveButton === 's3' }"
                       @click="handleButtonClick6('s3')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/training_system_hy_s3.png" alt=""/>
              </div>
            </div>
            <div class="left_system_item2">
              <div class="left_system_item2_cont">
                <img src="../assets/img/products/training_system_hy_s2.png" alt=""/>
                <div class="left_system_item2_text">
                  <p>心理压力评测训练系统(HY-S2)</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div2" :class="{ active: sysActiveButton === 's2' }"
                       @click="handleButtonClick6('s2')"><h2>了解详情</h2></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- center -->
        <div class="popular_system_center">
          <div class="center_system_content">
            <div class="center_system_item">
              <div class="center_system_item1_cont">
                <div class="center_system_item1_text">
                  <p>心理压力评测训练系统(HY-S1)</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div3" :class="{ active: sysActiveButton === 's1' }"
                       @click="handleButtonClick6('s1')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/training_system_hy_s1.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="popular_system_right">
          <div class="right_system_content">
            <div class="right_system_item1">
              <div class="right_system_item1_cont">
                <div class="right_system_item1_text">
                  <p>心理压力评测训练系统(HY-S4)</p>
                  <span>Psychological evaluation training system</span>
                </div>
                <img src="../assets/img/products/training_system_hy_s4.png" alt=""/>
                <div class="detail_div4" :class="{ active: sysActiveButton === 's4' }"
                     @click="handleButtonClick6('s4')"><h2>了解详情</h2></div>
              </div>
            </div>
            <div class="right_system_item2">
              <div class="right_system_item2_cont">
                <div class="right_system_item2_text" style="display: flex">
                  <div>
                    <p>心理压力评测训练系统(HY-S5)</p>
                    <span>Psychological evaluation training system</span>
                  </div>
                  <div class="right_img">
                    <img src="../assets/img/products/training_system_hy_s5_1.png"/>
                  </div>
                </div>
                <img src="../assets/img/products/training_system_hy_s5_2.png" alt=""/>
                <div class="detail_div5" :class="{ active: sysActiveButton === 's5' }"
                     @click="handleButtonClick6('s5')"><h2>了解详情</h2></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popularProduct" v-show="showD">
      <div class="popular_system">
        <!-- left -->
        <div class="popular_system_left">
          <div class="left_system_content">
            <div class="left_system_item1">
              <div class="left_system_item1_cont2">
                <div class="left_system_item1_text2">
                  <p>臻芯椅</p>
                  <span>Zhen Xin Chair</span>
                  <div class="detail_div_2" :class="{ active: sysActiveButton2 === 'zhen' }"
                       @click="handleButtonClick7('zhen')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/Zhen_Xin_Chair.png" alt=""/>
              </div>
            </div>
            <div class="left_system_item2">
              <div class="left_system_item2_cont_2">
                <img src="../assets/img/products/AI_Meridian_Chair.png" alt=""/>
                <div class="left_system_item2_text2">
                  <p>AI经络椅</p>
                  <span>AI Meridian Chair</span>
                  <div class="detail_div2_2" :class="{ active: sysActiveButton2 === 'ai' }"
                       @click="handleButtonClick7('ai')"><h2>了解详情</h2></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- center -->
        <div class="popular_system_center">
          <div class="center_system_content">
            <div class="center_system_item">
              <div class="center_system_item1_cont2">
                <div class="center_system_item1_text_2">
                  <p>鲲鹏椅</p>
                  <span>Kunpeng Chair</span>
                  <div class="detail_div3_2" :class="{ active: sysActiveButton2 === 'kun' }"
                       @click="handleButtonClick7('kun')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/Kunpeng_Chair.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="popular_system_right">
          <div class="center_system_content">
            <div class="center_system_item">
              <div class="center_system_item1_cont3">
                <div class="center_system_item1_text_2">
                  <p>极智椅</p>
                  <span>Jizhi Chair</span>
                  <div class="detail_div3_2" :class="{ active: sysActiveButton2 === 'ji' }"
                       @click="handleButtonClick7('ji')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/Jizhi_Chair.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popularProduct" v-show="showE">
      <div class="popular_system">
        <div class="popular_device_center">
          <div class="center_device_content">
            <div class="center_device_item">
              <div class="center_device_item_cont">
                <div class="center_device_item_text">
                  <p>心理压力评测训练系统(HY-S1)设备</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div_device" :class="{ active: sysActiveButton3 === 'hy-s1' }"
                       @click="handleButtonClick8('hy-s1')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/device_hy_s1.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div class="popular_device_center">
          <div class="center_device_content">
            <div class="center_device_item">
              <div class="center_device_item_cont">
                <div class="center_device_item_text">
                  <p>心理压力评测训练系统(HY-S2)设备</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div_device" :class="{ active: sysActiveButton3 === 'hy-s2' }"
                       @click="handleButtonClick8('hy-s2')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/device_hy_s2.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div class="popular_device_center">
          <div class="center_device_content">
            <div class="center_device_item">
              <div class="center_device_item_cont">
                <div class="center_device_item_text">
                  <p>心理压力评测训练系统(HY-S3)设备</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div_device" :class="{ active: sysActiveButton3 === 'hy-s3' }"
                       @click="handleButtonClick8('hy-s3')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/device_hy_s3.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div class="popular_device_center">
          <div class="center_device_content">
            <div class="center_device_item">
              <div class="center_device_item_cont">
                <div class="center_device_item_text">
                  <p>心理压力评测训练系统(HY-S4)设备</p>
                  <span>Psychological evaluation training system</span>
                  <div class="detail_div_device" :class="{ active: sysActiveButton3 === 'hy-s4' }"
                       @click="handleButtonClick8('hy-s4')"><h2>了解详情</h2></div>
                </div>
                <img src="../assets/img/products/device_hy_s4.png" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--沙画机-->
    <div class="machine">
      <h1>智能心理减压沙画机</h1>
      <h2>INTELLIGENT PRESSURE REDUCING SAND PAINTING MACHINE</h2>
      <div class="machineCont">
        <div class="machineImg">
          <img src="../assets/img/products/painting_machine.png"/>
        </div>
        <div class="machineItem">
          <div class="machineItem1">
            <div class="machineItem1Cont">
              <div class="machineItem1Text">
                <p>三款尺寸任您挑选</p>
              </div>
              <img src="../assets/img/products/machine1.png" alt=""/>
              <div class="detail_div6" :class="{ active: sandActiveButton === 'sand' }"
                   @click="handleButtonClick5('sand')"><h3>了解详情</h3></div>
              <div class="machineItem1Text2">
                <p>HY-Z1型<span>15英寸</span></p>
              </div>
            </div>
          </div>
          <div class="machineItem2">
            <div class="machineItem2Cont">
              <img src="../assets/img/products/machine2.png" alt=""/>
              <div class="detail_div7" :class="{ active: sandActiveButton === 'sand2' }"
                   @click="handleButtonClick5('sand2')"><h3>了解详情</h3></div>
              <div class="machineItem1Text2">
                <p>HY-Z2型<span>11英寸</span></p>
              </div>
            </div>
          </div>
          <div class="machineItem3">
            <div class="machineItem3Cont">
              <img src="../assets/img/products/machine3.png" alt=""/>
              <div class="detail_div8" :class="{ active: sandActiveButton === 'sand3' }"
                   @click="handleButtonClick5('sand3')"><h3>了解详情</h3></div>
              <div class="machineItem1Text2">
                <p>HY-Z3型<span>8英寸</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--VR-->
    <div class="vr">
      <h1>智能VR心理疏导系统</h1>
      <h2>INTELLIGENT VR PSYCHOLOGICAL COUNSELING SYSTEM</h2>
      <div class="vrCont">
        <div class="vrItem">
          <div class="vrItem1">
            <img src="../assets/img/products/vr_img.png" alt=""/>
          </div>
          <div class="vrItem2">
            <div class="vrItem2Cont">
              <img src="../assets/img/products/hy_v2.png" alt=""/>
              <div class="vrItem2Text">
                <p>HY-V1型</p>
                <div class="detail_vr" :class="{ active: vrActiveButton === 'vr' }" @click="handleButtonClick4('vr')">
                  <h2>了解详情</h2></div>
              </div>
            </div>
          </div>
          <div class="vrItem3">
            <div class="vrItem3Cont">
              <img src="../assets/img/products/hy_v1.png" alt=""/>
              <div class="vrItem3Text">
                <p>HY-V2型</p>
                <div class="detail_vr2" :class="{ active: vrActiveButton === 'vr2' }"
                     @click="handleButtonClick4('vr2')"><h2>了解详情</h2></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--其他-->
    <div class="other">
      <h1>其他产品</h1>
      <h2>OTHER PRODUCTS</h2>
      <div class="otherCont">
        <div class="otherItem">
          <div class="otherItem1">
            <img src="../assets/img/products/mirror.png" alt=""/>
          </div>
          <div class="otherItem2">
            <div class="otherItem2Cont">
              <div class="otherItem2Text">
                <p>专业智能力量健身镜商务版(IM-8C40)</p>
                <span>家庭式互动 更多沉浸体验</span>
                <div class="detail_other" @click="handleClick4()"><h2>了解详情</h2></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--按摩小件推荐-->
    <div class="massage">
      <h1>按摩小件推荐</h1>
      <h2>MASSAGE PRODUCT SMALL PIECES</h2>
      <div class="massageCont">
        <div class="massageItem1">
          <img src="../assets/img/products/massage_img1.png" alt=""/>
        </div>
        <div class="massageItem2">
          <img src="../assets/img/products/massage_img2.png" alt=""/>
        </div>
        <div class="massageItem3">
          <img src="../assets/img/products/massage_img3.png" alt=""/>
        </div>
        <div class="massageItem4">
          <img src="../assets/img/products/massage_img4.png" alt=""/>
        </div>
      </div>
      <div class="massageCont2">
        <div class="massageItem5">
          <div class="massageItemText">
            <p>智能减压颈部按摩产品</p>
            <div class="detail_massage" :class="{ active: pieceActiveButton === 'piece' }"
                 @click="handleButtonClick3('piece')"><h2>了解详情</h2></div>
          </div>
        </div>
        <div class="massageItem6">
          <div class="massageItemText">
            <p>眼部按摩仪</p>
            <div class="detail_massage" :class="{ active: pieceActiveButton === 'piece2' }"
                 @click="handleButtonClick3('piece2')"><h2>了解详情</h2></div>
          </div>
        </div>
        <div class="massageItem7">
          <div class="massageItemText">
            <p>眼部按摩仪PRO</p>
            <div class="detail_massage" :class="{ active: pieceActiveButton === 'piece3' }"
                 @click="handleButtonClick3('piece3')"><h2>了解详情</h2></div>
          </div>
        </div>
        <div class="massageItem8">
          <div class="massageItemText">
            <p>筋膜枪-摩力小拳王</p>
            <div class="detail_massage" :class="{ active: pieceActiveButton === 'piece4' }"
                 @click="handleButtonClick3('piece4')"><h2>了解详情</h2></div>
          </div>
        </div>
      </div>
    </div>

    <div class="beijing"></div>

    <!-- 底部 -->
    <footer2></footer2>
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import banner from "../components/banner.vue";
import footer2 from "../components/footer.vue";

export default {
  name: "App",
  data() {
    return {
      activeButton: 'train',
      systemActiveButton: 'active',
      systemUrl: require('@/assets/img/products/training_system.png'),
      systemActiveUrl: require('@/assets/img/products/training_system_active.png'),
      massageActiveButton: '',
      massageUrl: require('@/assets/img/products/massage_chair.png'),
      massageActiveUrl: require('@/assets/img/products/massage_chair_active.png'),
      deviceActiveButton: '',
      deviceUrl: require('@/assets/img/products/training_device.png'),
      deviceActiveUrl: require('@/assets/img/products/training_device_active.png'),
      pieceActiveButton: 'piece',
      vrActiveButton: 'vr',
      sandActiveButton: 'sand',
      sysActiveButton: 's3',
      sysActiveButton2: 'zhen',
      sysActiveButton3: 'hy-s1',
      navActiveButton: 'nav1',
      bannerList: [
        // {
        //   imgUrl: require('@/assets/img/home/home_banner.png')
        // },
        {
          imgUrl: require('@/assets/img/home/home_banner2.png')
        },
        {
          imgUrl: require('@/assets/img/home/home_banner3.png')
        },
        {
          imgUrl: require('@/assets/img/home/home_banner4.png')
        }
      ],
      showA: true,
      showB: false,
      showC: true,
      showD: false,
      showE: false,
      isFixed: false
    };
  },
  components: {
    navigation,
    banner,
    footer2,
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop) // 监听页面滚动
  },
  methods: {
    //通过宽度自适应 （获取屏幕宽度并计算比例）
    fontSize(res) {
      let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      //alert(res * fontSize);  // 12 6.25
      //alert(window.innerWidth);// 1920 1000
      //alert(document.documentElement.clientWidth); // 1920 1000
      //alert(document.body.clientWidth); // 1920 1000
      return res * fontSize;
    },
    // 获取页面滚动距离
    scrollToTop() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //console.log(scrollTop)

      if (scrollTop > this.fontSize(8.26)) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }

      if (scrollTop < this.fontSize(21.00)) {
        this.navActiveButton = 'nav1';
      } else if (scrollTop >= this.fontSize(21.70) && scrollTop < this.fontSize(33.70)) {
        this.navActiveButton = 'nav2';
      } else if (scrollTop > this.fontSize(33.70) && scrollTop < this.fontSize(42.00)) {
        this.navActiveButton = 'nav3';
      } else if (scrollTop > this.fontSize(42.00) && scrollTop < this.fontSize(50.00)) {
        this.navActiveButton = 'nav5';
      } else if (scrollTop > this.fontSize(50.00) && scrollTop < this.fontSize(56.00)) {
        this.navActiveButton = 'nav6';
      } else if (scrollTop > this.fontSize(56.00) && scrollTop < this.fontSize(61.11)) {
        this.navActiveButton = 'nav4';
      }

      // if (scrollTop < this.fontSize(9.19)) {
      //   this.navActiveButton = 'nav1';
      // } else if (scrollTop > this.fontSize(23.72) && scrollTop < this.fontSize(35.29)) {
      //   this.navActiveButton = 'nav2';
      // } else if (scrollTop > this.fontSize(35.29) && scrollTop < this.fontSize(44.29)) {
      //   this.navActiveButton = 'nav3';
      // } else if (scrollTop > this.fontSize(44.29) && scrollTop < this.fontSize(52.79)) {
      //   this.navActiveButton = 'nav5';
      // } else if (scrollTop > this.fontSize(52.79) && scrollTop < this.fontSize(59.29)) {
      //   this.navActiveButton = 'nav6';
      // } else if (scrollTop > this.fontSize(59.29) && scrollTop < this.fontSize(61.11)) {
      //   this.navActiveButton = 'nav4';
      // }
    },
    handleButtonClick(value) {
      this.activeButton = value
      if (value == 'train') {
        this.showA = true;
        this.showB = false;
      } else if (value == 'chair') {
        this.showA = false;
        this.showB = true;
      }
    },
    handleButtonClick2(value) {
      if (value == 'system') {
        this.showC = true;
        this.showD = false;
        this.showE = false;
        this.systemActiveButton = 'active';
        this.massageActiveButton = '';
        this.deviceActiveButton = '';
      } else if (value == 'chair') {
        this.showC = false;
        this.showD = true;
        this.showE = false;
        this.systemActiveButton = '';
        this.massageActiveButton = 'active';
        this.deviceActiveButton = '';
      } else if (value == 'device') {
        this.showC = false;
        this.showD = false;
        this.showE = true;
        this.systemActiveButton = '';
        this.massageActiveButton = '';
        this.deviceActiveButton = 'active';
      }
    },
    handleButtonClick3(value) {
      this.pieceActiveButton = value
      if(value=='piece') {
        const router = this.$router.resolve({ path: '/neck_massage' })
        window.open(router.href, '_blank')
      }
      if(value=='piece2') {
        const router = this.$router.resolve({ path: '/eye_massage' })
        window.open(router.href, '_blank')
      }
      if(value=='piece3') {
        const router = this.$router.resolve({ path: '/eye_pro_massage' })
        window.open(router.href, '_blank')
      }
      if(value=='piece4') {
        const router = this.$router.resolve({ path: '/fascia_massage' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick4(value) {
      this.vrActiveButton = value
      if(value=='vr') {
        const router = this.$router.resolve({ path: '/vr_hy_v1' })
        window.open(router.href, '_blank')
      }
      if(value=='vr2') {
        const router = this.$router.resolve({ path: '/vr_hy_v2' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick5(value) {
      this.sandActiveButton = value
      if(value=='sand') {
        const router = this.$router.resolve({ path: '/sand_15' })
        window.open(router.href, '_blank')
      }
      if(value=='sand2') {
        const router = this.$router.resolve({ path: '/sand_11' })
        window.open(router.href, '_blank')
      }
      if(value=='sand3') {
        const router = this.$router.resolve({ path: '/sand_8' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick6(value) {
      this.sysActiveButton = value
      if(value=='s3') {
        const router = this.$router.resolve({ path: '/training_system_s3' })
        window.open(router.href, '_blank')
      }
      if(value=='s2') {
        const router = this.$router.resolve({ path: '/training_system_s2' })
        window.open(router.href, '_blank')
      }
      if(value=='s1') {
        const router = this.$router.resolve({ path: '/training_system_s1' })
        window.open(router.href, '_blank')
      }
      if(value=='s4') {
        const router = this.$router.resolve({ path: '/training_system_s4' })
        window.open(router.href, '_blank')
      }
      if(value=='s5') {
        const router = this.$router.resolve({ path: '/training_system_s5' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick7(value) {
      this.sysActiveButton2 = value
      if(value=='zhen') {
        const router = this.$router.resolve({ path: '/chair_zhenxin' })
        window.open(router.href, '_blank')
      }
      if(value=='ai') {
        const router = this.$router.resolve({ path: '/chair_ai' })
        window.open(router.href, '_blank')
      }
      if(value=='kun') {
        const router = this.$router.resolve({ path: '/chair_kunpeng' })
        window.open(router.href, '_blank')
      }
      if(value=='ji') {
        const router = this.$router.resolve({ path: '/chair_jizhi' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick8(value) {
      this.sysActiveButton3 = value
      if(value=='hy-s1'){
        const router = this.$router.resolve({ path: '/device_s1' })
        window.open(router.href, '_blank')
      }
      if(value=='hy-s2'){
        const router = this.$router.resolve({ path: '/device_s2' })
        window.open(router.href, '_blank')
      }
      if(value=='hy-s3'){
        const router = this.$router.resolve({ path: '/device_s3' })
        window.open(router.href, '_blank')
      }
      if(value=='hy-s4'){
        const router = this.$router.resolve({ path: '/device_s4' })
        window.open(router.href, '_blank')
      }
    },
    handleButtonClick9(value) {
      this.navActiveButton = value
      if (value == 'nav1') {
        let items = document.querySelectorAll(".recommend");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      } else if (value == 'nav2') {
        let items = document.querySelectorAll(".popular");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop - 100
        console.log(offsetTop);
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      } else if (value == 'nav3') {
        let items = document.querySelectorAll(".machine");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop - 25
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      } else if (value == 'nav4') {
        let items = document.querySelectorAll(".massage");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop - 50
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      } else if (value == 'nav5') {
        let items = document.querySelectorAll(".vr");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop - 10
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      } else if (value == 'nav6') {
        let items = document.querySelectorAll(".other");
        //缓慢移动至目标位置
        // items[0].scrollIntoView({behavior: "smooth"});
        const offsetTop = items[0].offsetTop - 50
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    },
    handleClick(){
      const router = this.$router.resolve({ path: '/camo_detail' })
      window.open(router.href, '_blank')
    },
    handleClick2(){
      const router = this.$router.resolve({ path: '/camo_device_detail' })
      window.open(router.href, '_blank')
    },
    handleClick3(){
      const router = this.$router.resolve({ path: '/camo_chair_detail' })
      window.open(router.href, '_blank')
    },
    handleClick4(){
      const router = this.$router.resolve({ path: '/mirror_detail' })
      window.open(router.href, '_blank')
    }

  },
  // 滚动重置
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
};
</script>

<style scoped>
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}

/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

.products {
  width: 100vw;
  margin: 0 auto;
  height: 100%
}

/* 产品导航栏 */
.productNav {
  width: 100vw;
  height: 102px;
  background: #F0F1F5;
}

.productNav.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

.productNavCont {
  width: 95vw;
  margin: 0 auto;
}

.productNavContItems {
  height: 102px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
}

.productNavContItem {
  text-align: center;
  width: 300px;
  height: 102px;
}

.productNavContItem img {
  margin-top: 30px;
  width: 80px;
  height: 80px;
  border: 1px dashed;
}

.productNavContItem p {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  /*color: #252525;*/
  color: #6E6C6C;
  /*line-height: 25px;*/
  margin: 30px 0 0 0;
}

.productNavContItem span {
  width: 300px;
  /*height: 60px;*/
  margin-top: 10px;
  display: block;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #B5B5B5;
  line-height: 20px;
}

.productNavContItem:hover {
  cursor: pointer;
}

.productNavContItem.active p {
  color: #252525;
  font-weight: 600;
}

.productNavContItem.active span {
  color: #000000;
  font-weight: 600;
}

.productNavContLine {
  float: left;
  width: 1px;
  height: 35px;
  background: #CDCDCD;
  margin-top: 40px
}

/* 主推产品 */
.recommend {
  height: 913px;
  /*width: 1920px;*/
  background-image: url("../assets/img/products/recommend_product_background.png");
  background-size: contain;
}

.recommend h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 68px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.recommend h2 {
  color: #B0B0B0;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.recommendProduct {
  margin-top: 45px;
  height: 735px;
  width: 1920px;
}

.recommendProductItem {
  height: 735px;
  display: flex;
}

.recommendProductItemDiv1 {
  width: 600px;
  height: 735px;
}

.recommendProductItemDiv1 p {
  margin-top: 72px;
  margin-left: 114px;
  font-size: 50px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #4B72B8;
  line-height: 33px;
}

.recommendProductItemDiv1 span {
  /*width: 568px;*/
  height: 70px;
  margin-top: 24px;
  margin-left: 114px;
  display: inline-block;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 28px;
}

.div1More {
  width: 150px;
  height: 36px;
  border-radius: 38px 38px 38px 38px;
  opacity: 1;
  margin-left: 114px;
  border: 1px solid #000000;
}

.div1More h5 {
  margin-left: 50px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.div1More:hover {
  cursor: pointer;
}

.recommendProductItemDiv2 {
  /*width: 1320px;*/
  margin: 0 auto;
  height: 735px;
  /*padding-top: 91px;*/
}

.div2Item {
  width: 1320px;
  height: 690px;
  margin-top: 45px;
}

.div2ItemContent {
  display: flex;
  height: 100%;
}

.div2ItemContent img {
  width: 599px;
  height: 590px;
}

.div2ItemText {
  /*width: 721px;*/
  height: 690px;
}

.div2ItemText h3 {
  margin-top: 400px;
  margin-left: 100px;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 33px;
  width: 372px;
}

.div2ItemText h4 {
  font-size: 24px;
  margin-left: 100px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 33px;
}

.div2ItemText span {
  width: 440px;
  height: 140px;
  margin-top: 24px;
  margin-left: 100px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.recommendNav {
  height: 540px;
  width: 1920px;
}

.recommendNavCont {
  width: 1920px;
  /*margin-left: 100px;*/
  /*margin: 0 auto;*/
}

.recommendNavContItems {
  height: 76px;
  display: flex;
  flex-wrap: wrap;
  /*justify-content: space-between;*/
  align-content: space-between;
}

.recommendNavContDiv {
  margin-left: 120px;
}

.recommendNavContItem {
  text-align: center;
  width: 237px;
  height: 74px;
  opacity: 1;
  border-radius: 0px 0px 0px 0px;
  /*margin: 0 -1px -1px 0;*/ /*去除重叠的边框线*/
  border: 1px solid #DCDCDC;
}

.recommendNavContItem p {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  /*color: #252525;*/
  color: #9F9F9F;
  /*line-height: 25px;*/
  margin: 30px 0 0 0;
}

.recommendNavContItem:hover {
  cursor: pointer;
}

.recommendNavContItem.active {
  background-color: #4B72B8;
  /*color: white;*/
}

.recommendNavContItem.active p {
  color: #FFFFFF;
}

.recommendNavCont2 {
  width: 1920px;
  /*height: 464px;*/
}

.recommendNavCont2Div {
  width: 1920px;
  margin: 0 auto;
  /*height: 464px;*/
  /*padding-top: 91px;*/
}

.cont2DivItem {
  width: 1920px;
  /*height: 464px;*/
  margin-top: 45px;
}

.cont2DivItemDiv {
  margin-left: 110px;
  height: 464px;
  width: 1px;
  float: left;
}

.cont2DivContent {
  display: flex;
  height: 100%;
}

.cont2DivContent img {
  width: 485px;
  height: 424px;
}

.cont2DivText {
  width: 750px;
  /*height: 464px;*/
}

.cont2DivText h3 {
  margin-top: 200px;
  margin-left: 100px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 33px;
  width: 372px;
}

.cont2DivText h4 {
  font-size: 14px;
  margin-left: 100px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 33px;
}

.cont2DivText span {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.cont2DivText2 {
  width: 750px;
  height: 464px;
}

.cont2DivText2 h3 {
  margin-top: 130px;
  margin-left: 100px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 33px;
  width: 372px;
}

.cont2DivText2 h4 {
  font-size: 14px;
  margin-left: 100px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 33px;
}

.cont2DivText2 span {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.cont2DivMore {
  /*height: 464px;*/
}

.cont2More {
  width: 150px;
  height: 36px;
  border-radius: 38px 38px 38px 38px;
  opacity: 1;
  margin-top: 250px;
  margin-left: 114px;
  border: 1px solid #000000;
}

.cont2More h5 {
  margin-left: 50px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.cont2More:hover{
  cursor: pointer;
}

/* 热门产品推荐 */
.popular {
  height: 280px;
  /*width: 1920px;*/

}

.popular h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 90px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.popular h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.popularItem {
  margin: 10px 450px;
  justify-content: space-between;
  /*display: flex;*/
  display: flex;
  width: 1000px;
  height: 180px;
}

.popularItem1 {
  margin-right: 16px;
  position: relative;
  width: 180px;
  height: 100px;
  background-color: rgba(255, 255, 255, 1);
  /*box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);*/
  border-radius: 10px;
}

.popularItem1 span {
  position: absolute;
  left: 120px;
  top: 30px;
  display: inline-block;
  /*border-radius: 100%;*/
  width: 57px;
  height: 57px;
  /*background-color: rgba(52, 145, 229, 1);*/
}

.popularItem1 span:hover {
  cursor: pointer;
}

.popularItemImg {
  height: 57px;
  width: 57px;
}

.popularItemText {
  position: absolute;
  top: 90px;
  left: 110px;
  width: 100px;
  color: #AEAEAE;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
}

.popularItemText.active {
  color: #8AB3DF;
}

.popularItemText2 {
  position: absolute;
  top: 90px;
  left: 110px;
  width: 100px;
  color: #AEAEAE;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
}

.popularItemText2.active {
  color: #8AB3DF;
}

.popularItemText3 {
  position: absolute;
  top: 90px;
  left: 110px;
  width: 100px;
  color: #AEAEAE;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
}

.popularItemText3.active {
  color: #8AB3DF;
}

.popularProduct {
  height: 877px;
  width: 1920px;
  background: #F9F9F9;
}

.popular_system {
  width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.popular_system_left {
  padding-top: 51px;
}

.left_system_content {

}

.left_system_item1 {
  width: 615px;
  height: 383px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.left_system_item1 img {
  width: 588px;
  height: 353px;
  margin-top: 41px;
}

.left_system_item2 {
  margin-top: 24px;
  width: 615px;
  height: 383px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.left_system_item1_cont {
  display: flex;
  margin-bottom: 40px;
}

.left_system_item1_cont img {
  margin-top: 92px;
  margin-left: 30px;
  width: 270px;
  height: 223px;
}

.left_system_item1_cont2 {
  display: flex;
  margin-bottom: 40px;
}

.left_system_item1_cont2 img {
  margin-top: 62px;
  margin-left: 30px;
  width: 256px;
  height: 256px;
}

.left_system_item1_text {
  /*background: #ffffff;*/
  width: 250px;
  height: 340px;
}

.left_system_item1_text p {
  margin-top: 92px;
  margin-left: 58px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.left_system_item1_text span {
  margin-top: 10px;
  margin-left: 58px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.left_system_item1_text2 {
  /*background: #ffffff;*/
  width: 250px;
  height: 340px;
}

.left_system_item1_text2 p {
  margin-top: 120px;
  margin-left: 58px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.left_system_item1_text2 span {
  margin-top: 20px;
  margin-left: 58px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.detail_div {
  width: 131px;
  height: 38px;
  margin-top: 60px;
  margin-left: 58px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div:hover {
  cursor: pointer;
}

.detail_div.active {
  background: #4B72B8;
}

.detail_div.active h2 {
  color: #FFFFFF;
}

.detail_div_2 {
  width: 131px;
  height: 38px;
  margin-top: 70px;
  margin-left: 58px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div_2 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div_2:hover {
  cursor: pointer;
}

.detail_div_2.active {
  background: #4B72B8;
}

.detail_div_2.active h2 {
  color: #FFFFFF;
}

.left_system_item2 img {
  width: 588px;
  height: 353px;
  margin-top: 41px;
}

.left_system_item2_cont {
  display: flex;
  margin-bottom: 40px;
}

.left_system_item2_cont img {
  margin-top: 92px;
  margin-left: 50px;
  width: 219px;
  height: 183px;
}

.left_system_item2_cont_2 {
  display: flex;
  margin-bottom: 40px;
}

.left_system_item2_cont_2 img {
  margin-top: 92px;
  margin-left: 50px;
  width: 243px;
  height: 243px;
}

.left_system_item2_text {
  /*background: #ffffff;*/
  width: 250px;
  height: 340px;
}

.left_system_item2_text p {
  margin-top: 92px;
  margin-left: 58px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.left_system_item2_text span {
  margin-top: 10px;
  margin-left: 58px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.left_system_item2_text2 {
  /*background: #ffffff;*/
  width: 250px;
  height: 340px;
}

.left_system_item2_text2 p {
  margin-top: 130px;
  margin-left: 58px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.left_system_item2_text2 span {
  margin-top: 20px;
  margin-left: 58px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.detail_div2 {
  width: 131px;
  height: 38px;
  margin-top: 60px;
  margin-left: 58px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div2 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div2:hover {
  cursor: pointer;
}

.detail_div2.active {
  background: #4B72B8;
}

.detail_div2.active h2 {
  color: #FFFFFF;
}

.detail_div2_2 {
  width: 131px;
  height: 38px;
  margin-top: 80px;
  margin-left: 58px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div2_2 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div2_2:hover {
  cursor: pointer;
}

.detail_div2_2.active {
  background: #4B72B8;
}

.detail_div2_2.active h2 {
  color: #FFFFFF;
}


.popular_system_center {
  padding-top: 51px;
}

.popular_device_center {
  padding-top: 51px;
}

.center_system_content {

}

.center_device_content {

}

.center_system_item {
  width: 458px;
  height: 790px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.center_device_item {
  width: 374px;
  height: 790px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.center_system_item1_cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.center_system_item1_cont img {
  margin-top: 70px;
  margin-left: 30px;
  width: 391px;
  height: 386px;
}


.center_system_item1_cont2 {
  /*display: flex;*/
  margin-bottom: 40px;
}

.center_system_item1_cont2 img {
  margin-top: 70px;
  margin-left: 30px;
  width: 346px;
  height: 443px;
}

.center_system_item1_cont3 {
  /*display: flex;*/
  margin-bottom: 40px;
}

.center_system_item1_cont3 img {
  margin-top: 70px;
  margin-left: 30px;
  width: 340px;
  height: 402px;
}

.center_device_item_cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.center_device_item_cont img {
  margin-top: 70px;
  margin-left: 60px;
  width: 216px;
  height: 415px;
}

.center_system_item1_text {
  /*background: #ffffff;*/
  width: 350px;
  /*height: 340px;*/
}

.center_system_item1_text p {
  /*margin-top: 92px;*/
  width: 160px;
  height: 44px;
  padding-top: 81px;
  padding-left: 52px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.center_system_item1_text span {
  width: 300px;
  height: 44px;
  margin-top: 10px;
  margin-left: 52px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}


.center_system_item1_text_2 {
  /*background: #ffffff;*/
  width: 350px;
  /*height: 340px;*/
}

.center_system_item1_text_2 p {
  /*margin-top: 92px;*/
  width: 160px;
  /*height: 44px;*/
  padding-top: 81px;
  padding-left: 52px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.center_system_item1_text_2 span {
  width: 300px;
  height: 44px;
  margin-top: 20px;
  margin-left: 52px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.center_device_item_text {
  /*background: #ffffff;*/
  width: 350px;
  /*height: 340px;*/
}

.center_device_item_text p {
  /*margin-top: 92px;*/
  width: 160px;
  /*height: 44px;*/
  padding-top: 81px;
  padding-left: 52px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.center_device_item_text span {
  width: 300px;
  height: 44px;
  margin-top: 20px;
  margin-left: 52px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.detail_div3 {
  width: 131px;
  height: 38px;
  margin-top: 25px;
  margin-left: 58px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div3 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div3:hover {
  cursor: pointer;
}

.detail_div3.active {
  background: #4B72B8;
}

.detail_div3.active h2 {
  color: #FFFFFF;
}

.detail_div3_2 {
  width: 131px;
  height: 38px;
  margin-top: 25px;
  margin-left: 52px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div3_2 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div3_2:hover {
  cursor: pointer;
}

.detail_div3_2.active {
  background: #4B72B8;
}

.detail_div3_2.active h2 {
  color: #FFFFFF;
}

.detail_div_device {
  width: 131px;
  height: 38px;
  margin-top: 25px;
  margin-left: 52px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div_device h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div_device:hover {
  cursor: pointer;
}

.detail_div_device.active {
  background: #4B72B8;
}

.detail_div_device.active h2 {
  color: #FFFFFF;
}


.popular_system_right {
  padding-top: 51px;
}

.right_system_content {

}

.right_system_item1 {
  width: 458px;
  height: 436px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.right_system_item1 img {
  width: 588px;
  height: 353px;
  margin-top: 41px;
}

.right_system_item1_cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.right_system_item1_cont img {
  /*margin-top: 92px;*/
  margin-left: 60px;
  width: 216px;
  height: 199px;
}

.right_system_item1_text {
  /*background: #ffffff;*/
  width: 350px;
}

.right_system_item1_text p {
  /*margin-top: 92px;*/
  width: 170px;
  padding-top: 71px;
  margin-left: 58px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.right_system_item1_text span {
  width: 300px;
  margin-top: 10px;
  margin-left: 58px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.right_system_item2 {
  margin-top: 24px;
  width: 458px;
  height: 330px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.right_system_item2 img {
  width: 588px;
  height: 353px;
  margin-top: 41px;
}

.right_system_item2_cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.right_system_item2_cont img {
  /*margin-top: 92px;*/
  margin-left: 30px;
  width: 177px;
  height: 99px;
}

.right_system_item2_text {
  /*background: #ffffff;*/
  width: 250px;
  /*height: 340px;*/
}

.right_system_item2_text p {
  /*margin-top: 92px;*/
  width: 170px;
  padding-top: 61px;
  margin-left: 34px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.right_system_item2_text span {
  width: 275px;
  margin-top: 10px;
  margin-left: 34px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #AAAAAA;
  line-height: 16px;
}

.right_img {
  width: 77px;
  height: 70px;
  margin-top: 20px;
  margin-right: 10px;
}

.right_img img {
  width: 77px;
  height: 70px;
}

.detail_div4 {
  float: right;
  width: 131px;
  height: 38px;
  margin-top: 180px;
  margin-right: 20px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div4 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div4:hover {
  cursor: pointer;
}

.detail_div4.active {
  background: #4B72B8;
}

.detail_div4.active h2 {
  color: #FFFFFF;
}

.detail_div5 {
  float: right;
  width: 131px;
  height: 38px;
  margin-top: 100px;
  margin-right: 20px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div5 h2 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div5:hover {
  cursor: pointer;
}

.detail_div5.active {
  background: #4B72B8;
}

.detail_div5.active h2 {
  color: #FFFFFF;
}

/* 沙画机 */
.machine {
  height: 900px;
  /*width: 1920px;*/
}

.machineCont {
  /*display: flex;*/
}

.machine h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 120px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.machine h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.machineImg {
  width: 1582px;
  height: 355px;
  margin: 0 auto;
  margin-top: 50px;
}

.machineImg img {
  width: 1582px;
  height: 355px;
}

.machineItem {
  width: 1582px;
  height: 335px;
  /*background-color: red;*/
  margin: 0 auto;
  display: flex;
}

.machineItem1 {
  width: 527px;
  height: 335px;
  background-color: #F9F9F9;
}

.machineItem1Cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.machineItem1Cont img {
  margin-top: 49px;
  margin-left: 68px;
  width: 184px;
  height: 117px;
}

.machineItem1Text {
  /*background: #ffffff;*/
  width: 350px;
  /*height: 340px;*/
}

.machineItem1Text p {
  /*margin-top: 92px;*/
  width: 160px;
  height: 44px;
  padding-top: 41px;
  padding-left: 68px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.machineItem1Text2 {
  /*background: #ffffff;*/
  /*width: 350px;*/
  /*height: 340px;*/
}

.machineItem1Text2 p {
  width: 160px;
  height: 44px;
  padding-top: 41px;
  padding-left: 90px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #9B9B9B;
  line-height: 16px;
}

.machineItem1Text2 span {
  padding-left: 15px;
  line-height: 16px;
  color: #000000;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
}

.detail_div6 {
  float: right;
  width: 131px;
  height: 38px;
  margin-top: 100px;
  margin-right: 70px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div6 h3 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div6:hover {
  cursor: pointer;
}

.detail_div6.active {
  background: #4B72B8;
}

.detail_div6.active h3 {
  color: #FFFFFF;
}

.machineItem2 {
  width: 527px;
  height: 335px;
  background-color: #FFFFFF;
}

.machineItem2Cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.machineItem2Cont img {
  margin-top: 140px;
  margin-left: 68px;
  width: 167px;
  height: 106px;
}

.detail_div7 {
  float: right;
  width: 131px;
  height: 38px;
  margin-top: 190px;
  margin-right: 70px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div7 h3 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div7:hover {
  cursor: pointer;
}

.detail_div7.active {
  background: #4B72B8;
}

.detail_div7.active h3 {
  color: #FFFFFF;
}

.machineItem3 {
  width: 528px;
  height: 335px;
  background-color: #F9F9F9;
}

.machineItem3Cont {
  /*display: flex;*/
  margin-bottom: 40px;
}

.machineItem3Cont img {
  margin-top: 160px;
  margin-left: 68px;
  width: 113px;
  height: 78px;
}

.detail_div8 {
  float: right;
  width: 131px;
  height: 38px;
  margin-top: 190px;
  margin-right: 70px;
  /*background: #4B72B8;*/
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #BABABA;
  opacity: 1;
}

.detail_div8 h3 {
  margin-left: 30px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_div8:hover {
  cursor: pointer;
}

.detail_div8.active {
  background: #4B72B8;
}

.detail_div8.active h3 {
  color: #FFFFFF;
}

/* VR */
.vr {
  height: 850px;
  /*width: 1920px;*/
}

.vrCont {
  /*display: flex;*/
  margin-top: 50px;
}

.vr h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 170px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.vr h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.vrItem {
  width: 1920px;
  height: 600px;
  display: flex;
}

.vrItem1 {
  width: 820px;
  height: 518px;
}

.vrItem1 img {
  width: 820px;
  height: 518px;
}

.vrItem2 {
  width: 549px;
  height: 518px;
  background-color: #F9F9F9;
}

.vrItem2Cont {
  display: flex;
  margin-bottom: 40px;
}

.vrItem2Cont img {
  margin-top: 140px;
  margin-left: 68px;
  width: 262px;
  height: 305px;
}

.vrItem2Text {
  /*background: #ffffff;*/
  width: 219px;
  /*height: 340px;*/
}

.vrItem2Text p {
  /*margin-top: 92px;*/
  width: 160px;
  height: 44px;
  padding-top: 175px;
  padding-left: 60px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.detail_vr {
  margin-left: 28px;
  width: 144px;
  height: 33px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.detail_vr h2 {
  margin-left: 38px;
  /*width: 150px;*/
  height: 10px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 14px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_vr:hover {
  cursor: pointer;
}

.detail_vr.active {
  background-color: #4B72B8;
}

.detail_vr.active h2 {
  color: #FFFFFF;
}

.vrItem3 {
  width: 550px;
  height: 518px;
  background-color: #F9F9F9;
}

.vrItem3Cont {
  display: flex;
  margin-bottom: 40px;
}

.vrItem3Cont img {
  margin-top: 140px;
  margin-left: 68px;
  width: 219px;
  height: 295px;
}

.vrItem3Text {
  /*background: #ffffff;*/
  width: 219px;
  /*height: 340px;*/
}

.vrItem3Text p {
  /*margin-top: 92px;*/
  width: 160px;
  height: 44px;
  padding-top: 175px;
  padding-left: 60px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.detail_vr2 {
  margin-left: 28px;
  width: 144px;
  height: 33px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.detail_vr2 h2 {
  margin-left: 38px;
  /*width: 150px;*/
  height: 10px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 14px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_vr2:hover {
  cursor: pointer;
}

.detail_vr2.active {
  background-color: #4B72B8;
}

.detail_vr2.active h2 {
  color: #FFFFFF;
}

/* 其他 */
.other {
  height: 650px;
  /*width: 1920px;*/
}

.otherCont {
  /*display: flex;*/
  /*width: 80vw;*/
  width: 620px;
  height: 300px;
  margin: 0 auto;
  margin-top: 120px;
}

.other h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 100px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.other h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.otherItem {
  height: 300px;
  display: flex;
}

.otherItem1 {
  width: 310px;
  height: 282px;
}

.otherItem1 img {
  width: 310px;
  height: 282px;
}

.otherItem2 {
  width: 297px;
  height: 282px;
  background-color: #F9F9F9;
}

.otherItem2Cont {
  display: flex;
  margin-bottom: 40px;
}

.otherItem2Text {
  /*background: #ffffff;*/
  width: 300px;
  /*height: 340px;*/
}

.otherItem2Text p {
  /*margin-top: 92px;*/
  width: 220px;
  height: 44px;
  padding-top: 69px;
  padding-left: 49px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 21px;
}

.otherItem2Text span {
  margin-top: 20px;
  margin-left: 49px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #838383;
  line-height: 16px;
}

.detail_other {
  margin-top: 25px;
  margin-left: 49px;
  width: 144px;
  height: 33px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #B1B1B1;
  background-color: #4B72B8;
}

.detail_other h2 {
  margin-left: 38px;
  /*width: 150px;*/
  height: 10px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_other:hover {
  cursor: pointer;
}

/* 按摩小件 */
.massage {
  height: 480px;
  /*width: 1920px;*/
}

.massageCont {
  display: flex;
  /*width: 80vw;*/
  width: 1300px;
  /*height: 300px;*/
  margin: 0 auto;
  margin-top: 100px;
  justify-content: space-between;
}

.massage h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  padding-top: 80px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.massage h2 {
  color: #909090;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.massageItem1 {
  width: 284px;
  height: 250px;
  /*background-color: #000b6e;*/
}

.massageItem1 img {
  width: 284px;
  height: 250px;
}

.massageItem2 {
  width: 284px;
  height: 250px;
  /*background-color: #000b6e;*/
}

.massageItem2 img {
  width: 284px;
  height: 250px;
}

.massageItem3 {
  width: 284px;
  height: 250px;
  /*background-color: #000b6e;*/
}

.massageItem3 img {
  width: 284px;
  height: 250px;
}

.massageItem4 {
  width: 284px;
  height: 250px;
  /*background-color: #000b6e;*/
}

.massageItem4 img {
  width: 284px;
  height: 250px;
}

.massageCont2 {
  display: flex;
  /*width: 80vw;*/
  width: 1300px;
  /*height: 300px;*/
  margin: 0 auto;
  /*margin-top: 100px;*/
  justify-content: space-between;
}

.massageItem5 {
  width: 284px;
  height: 150px;
  background-color: #FFFFFF;
}

.massageItem6 {
  width: 284px;
  height: 150px;
  background-color: #FFFFFF;
}

.massageItem7 {
  width: 284px;
  height: 150px;
  background-color: #FFFFFF;
}

.massageItem8 {
  width: 284px;
  height: 150px;
  background-color: #FFFFFF;
}

.massageItemText {
  /*background: #ffffff;*/
  /*width: 300px;*/
  /*height: 340px;*/
}

.massageItemText p {
  /*margin-top: 92px;*/
  /*width: 160px;*/
  /*height: 22px;*/
  padding-top: 40px;
  /*padding-left: 49px;*/
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 19px;
}

.detail_massage {
  margin-top: 25px;
  margin-left: 68px;
  width: 144px;
  height: 33px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #B1B1B1;
  /*background-color: #4B72B8;*/
}

.detail_massage h2 {
  margin-left: 38px;
  /*width: 150px;*/
  height: 10px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 14px;
  color: #585858;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.detail_massage:hover {
  cursor: pointer;
}

.detail_massage.active {
  background-color: #4B72B8;
}

.detail_massage.active h2 {
  color: #FFFFFF;
}

.beijing {
  height: 284px;
  background-color: #F9F9F9;
}
</style>
